import { FC, Fragment, useState, useEffect } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";

interface ListProps {
  status: string;
  onSelect?: (status: string) => void;
}

type Status =
  | "menunggu konfirmasi"
  | "siap dikirim"
  | "dikirim"
  | "selesai"
  | "batal";

const data: Status[] = [
  "menunggu konfirmasi",
  "siap dikirim",
  "dikirim",
  "selesai",
  "batal",
];

const ListBox: FC<ListProps> = ({ onSelect = () => {}, status = "new" }) => {
  const [selected, setSelected] = useState<Status>(data[0]);

  const theOne = data.indexOf(selected);

  useEffect(() => {
    switch (status) {
      case "new":
        return setSelected(data[0]);
      case "ready":
        return setSelected(data[1]);
      case "delivered":
        return setSelected(data[2]);
      case "finished":
        return setSelected(data[3]);
      case "canceled":
        return setSelected(data[4]);
    }
  }, [status]);

  const handleSelect = (e: any) => {
    setSelected(e);
    onSelect(e);
  };
  return (
    <div className="text-sm">
      <Listbox value={selected} onChange={handleSelect}>
        <div className="relative  w-56">
          <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left text-gray-9000 dark:text-white bg-white dark:bg-neutral-900 rounded-lg ring-1 ring-neutral-200  cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-gray-500 focus-visible:ring-offset-primary-6000 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm text-gray-900">
            <span className="block truncate">{selected}</span>
            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <SelectorIcon
                className="w-5 h-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-sm dark:text-black bg-white dark:bg-neutral-900 rounded-md shadow-lg max-h-60 border-neutral-200  focus:outline-none sm:text-sm z-40">
              {data
                .filter((value, index) => index > theOne)
                .map((address, index) => {
                  if (theOne === 3) return <div key={index}></div>;
                  return (
                    <Listbox.Option
                      key={index}
                      className={({ active }) =>
                        `${
                          active
                            ? "text-gray-900 bg-primary-100"
                            : "text-gray-900 dark:text-white dark:bg-neutral-900"
                        }
                        cursor-default select-none relative py-2 pl-10 pr-4`
                      }
                      value={address}
                    >
                      {({ selected, active }) => (
                        <>
                          <span
                            className={`${
                              selected ? "font-medium" : "font-normal"
                            } block truncate`}
                          >
                            {address}
                          </span>
                          {selected ? (
                            <span
                              className={`${
                                active
                                  ? "text-primary-6000"
                                  : "text-primary-6000"
                              }
                              absolute inset-y-0 left-0 flex items-center pl-3`}
                            >
                              <CheckIcon
                                className="w-5 h-5"
                                aria-hidden="true"
                              />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  );
                })}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

export default ListBox;
